import { useState } from 'react';
import {
  CheckIcon,
  Popover,
  PopoverButton,
  PopoverContent,
  PopoverTrigger,
} from '@playerbase/ui';

import { useShell } from '../use-shell.js';

export function MilestoneSelector(): JSX.Element | null {
  const { activeGame, milestones, activeMilestone } = useShell();
  const [open, setOpen] = useState(false);

  if (activeGame === null) return null;

  // No empty-state CTA in the topbar - milestone creation lives in the
  // top-right TopbarActions group. Render nothing when there's nothing to pick.
  if (milestones.length === 0) return null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <PopoverButton size="sm">
          <span className="max-w-[14rem] truncate">
            {activeMilestone?.name ?? 'Select milestone'}
          </span>
        </PopoverButton>
      </PopoverTrigger>
      <PopoverContent className="w-[16rem]">
        <div className="px-3 pt-2 pb-1 text-[10px] font-mono uppercase tracking-wider text-text-muted">
          Milestones
        </div>
        {milestones.map((m) => (
          <button
            key={m.id}
            type="button"
            // TODO(milestones): re-scope the active milestone on click; for
            // now this only dismisses the popover.
            onClick={() => setOpen(false)}
            className="flex w-full items-center gap-2 rounded-sm px-3 py-2 text-left text-sm text-text hover:bg-surface-2"
          >
            <span className="flex-1 truncate">{m.name}</span>
            {activeMilestone?.id === m.id && <CheckIcon className="text-accent" />}
          </button>
        ))}
      </PopoverContent>
    </Popover>
  );
}
